import { useState, useEffect, useRef } from 'react'
import { Box, Button, Modal, Stack, Card, CardContent, Typography, TextField, Snackbar, Alert, MenuItem, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper
} from '@mui/material';
import moment from 'moment'
import 'moment/locale/th'
// Hooks
import useTrackDoc from './hooks/useTrackDoc';
import useUtilitiesSurveyData from '../../hooks/useUtilitiesSurveyData';


// ICON
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import SaveIcon from '@mui/icons-material/Save';
import ClearIcon from '@mui/icons-material/Clear';
import AddCircleIcon from '@mui/icons-material/AddCircle';


const cardBodyStyle = {
    border: ' grey',
    background: '#fafaeb',
    textAlign: 'center',
    m: 2,
    width: '90%',
    justifyContent: 'center',
    // borderRadius: 2,
}
const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    borderRadius: 2,
    boxShadow: 24,
    p: 4,
};
const initialForm = {
    parcelCode: '',
    oldParcel: '',
    parcelType: 1,
    dn: ''
};
const initialFormError = {
    parcelCode: '',
    oldParcel: '',
    parcelType: '',
    dn: ''
};

export default function ReceiveDocuments() {
    const [docData, setDocData] = useState([])
    const [barcode, setBarcode] = useState('')
    const inputRef = useRef(null); // ✅ useRef สำหรับโฟกัสช่องกรอก
    // Hooks
    const { fetchAndAppendFolderData, updateCurrentHolder, returnDoc, addFolder } = useTrackDoc()
    const { landTypeList } = useUtilitiesSurveyData()


    const handleBarcodeChange = (e) => {
        setBarcode(e.target.value.toUpperCase())
        // ที่นี่สามารถเพิ่ม logic การค้นหา หรือจัดการ barcode ได้
    };
    const handleBarcodeSubmit = (e) => {
        e.preventDefault()
        const found = docData.some(item => item.parcelCode === barcode);
        if (found) {
            console.log("พบ parcelCode ที่ตรงกับ Barcode");
        } else {
            fetchAndAppendFolderData(barcode, docData, setDocData, setOpenError, setErrorText)
            console.log("ไม่พบ parcelCode ที่ตรงกัน");
        }
        setBarcode('')
        // ที่นี่สามารถเพิ่ม logic การค้นหา หรือจัดการ barcode ได้
    };
    // Alert
    const [openSuccess, setOpenSuccess] = useState(false);
    const handleSuccessAlertClose = () => {
        setOpenSuccess(false);
        setSuccessText('')
        setDocData([])
        if (inputRef.current) {
            inputRef.current.focus();
        }
    };
    const [successText, setSuccessText] = useState('')
    const [openError, setOpenError] = useState(false)
    const handleErrorAlertClose = () => {
        setOpenError(false);
        setErrorText('')
    };
    const [errorText, setErrorText] = useState('')
    // 
    // Add Folder
    const [addModalOpen, setAddModalOpen] = useState(false)
    const [modalForm, setModalForm] = useState(initialForm);
    const handleModalClose = () => {
        setAddModalOpen(false)
        setModalForm(initialForm)
        setValidationErrors(initialFormError)
    };

    const handleModalFormChange = (e) => {
        setModalForm({ ...modalForm, [e.target.name]: e.target.value.toUpperCase() });
        setValidationErrors({ ...validationErrors, [e.target.name]: null }); // clear error เมื่อกรอกใหม่
    };

    const handleModalFormSave = (e) => {
        e.preventDefault()
        if (!validateForm()) return;
        addFolder(modalForm, setOpenSuccess, setOpenError, setSuccessText, setErrorText)
        console.log('ข้อมูลที่บันทึก:', modalForm);
        // คุณสามารถส่ง form นี้ไปยัง backend ได้ตรงนี้
        // handleModalClose();
    };
    // Validation
    const [validationErrors, setValidationErrors] = useState({});
    const validateForm = () => {
        const newErrors = {};
        if (!modalForm.parcelCode) newErrors.parcelCode = 'กรุณากรอกรหัสแปลงที่ดิน';
        if (!modalForm.oldParcel) newErrors.oldParcel = 'กรุณากรอกรหัสแปลงที่ดินเก่า';
        if (!modalForm.parcelType) newErrors.parcelType = 'กรุณาเลือกประเภทเอกสารสิทธิ์';
        if (!modalForm.dn) newErrors.dn = 'กรุณากรอกเลขเอกสารสิทธิ์ที่ดิน';
        setValidationErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    // 
    useEffect(() => {
        console.log(openSuccess)
    }, [openSuccess])
    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, [addModalOpen])

    return (
        <Box className='otherSide' id="otherSide">
            <Box className='surveyLayouts' id="surveyLayouts">
                {/* Alert */}
                <Snackbar
                    open={openSuccess}
                    autoHideDuration={2000}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center'
                    }}
                    onClose={handleSuccessAlertClose}
                >
                    <Alert variant='filled' severity="success" sx={{ width: '100%' }}>
                        {successText}
                    </Alert>
                </Snackbar>
                <Snackbar
                    open={openError}
                    autoHideDuration={3000}
                    onClose={handleErrorAlertClose}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center'
                    }}
                >
                    <Alert variant="filled" severity="error" sx={{ width: '100%' }}>
                        {errorText}
                    </Alert>
                </Snackbar>
                {/*  */}
                <Card sx={cardBodyStyle}>
                    <CardContent >
                        <Typography variant='h5'>ตารางรับเอกสาร</Typography>
                    </CardContent>
                    <CardContent>
                        {/* ช่องสแกน Barcode */}
                        <Box
                            mb={2}
                            component="form"
                            onSubmit={handleBarcodeSubmit}
                        >
                            <Typography variant="h6" gutterBottom>
                                สแกน Barcode เพื่อเพิ่มเอกสาร
                            </Typography>
                            <TextField
                                inputRef={inputRef} // ✅ ผูก ref กับช่องกรอก
                                label="Scan or Enter Barcode"
                                variant="outlined"
                                value={barcode}
                                onChange={handleBarcodeChange}
                            />
                            <Button
                                variant="contained"
                                color="secondary"
                                type='submit'
                                startIcon={<DocumentScannerIcon />}
                                sx={{ fontSize: '1.2rem', padding: '12px 24px', ml: 1 }}
                            >
                                สแกน
                            </Button>
                            <Button
                                variant="contained"
                                color="success"
                                startIcon={<AddCircleIcon />}
                                sx={{ fontSize: '1.2rem', padding: '12px 24px', ml: 1 }}
                                onClick={() => {
                                    setAddModalOpen(true)
                                }}
                            >
                                เพิ่มซองในระบบ
                            </Button>
                            <Button
                                variant="contained"
                                color="error"
                                startIcon={<ClearIcon />}
                                sx={{ fontSize: '1.2rem', padding: '12px 24px', ml: 1 }}
                                onClick={() => {
                                    setDocData([])
                                    if (inputRef.current) {
                                        inputRef.current.focus();
                                    }
                                }}
                            >
                                เอาออกทั้งหมด
                            </Button>
                        </Box>
                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center">รหัสแปลงที่ดินใหม่</TableCell>
                                        <TableCell align="center">รหัสแปลงที่ดินเก่า</TableCell>
                                        <TableCell align="center">ผู้ถือ</TableCell>
                                        <TableCell align="center">วันที่รับ</TableCell>
                                        <TableCell align="center"></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {docData.map((row, index) => (
                                        <TableRow key={index}>
                                            <TableCell align="center">{row.parcelCode || ' '}</TableCell>
                                            <TableCell align="center">{row.oldParcel || ' '}</TableCell>
                                            <TableCell align="center">{row.holder == 0 ? 'ห้องซอง' : row.fname + ' ' + row.lname}</TableCell>
                                            <TableCell align="center">{moment(row.recievedDate).add(543, 'year').format('วันที่ DD MMMM YYYY เวลา HH:mm:ss') || ' '}</TableCell>
                                            <TableCell align="center">
                                                <Button
                                                    variant='contained'
                                                    color='error'
                                                    startIcon={<RemoveCircleIcon />}
                                                    onClick={() => {
                                                        var arr = [...docData]
                                                        arr.splice(index, 1)
                                                        setDocData(arr)
                                                        if (inputRef.current) {
                                                            inputRef.current.focus();
                                                        }
                                                    }}
                                                >
                                                    เอาออก
                                                </Button>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={<SaveIcon />}
                            sx={{ fontSize: '1.2rem', padding: '12px 24px', m: 1 }}
                            onClick={() => { updateCurrentHolder(docData, setOpenSuccess, setOpenError, setSuccessText, setErrorText) }}
                        >
                            รับเอกสาร
                        </Button>
                        <Button
                            variant="contained"
                            color="warning"
                            startIcon={<SaveIcon />}
                            sx={{ fontSize: '1.2rem', padding: '12px 24px', m: 1 }}
                            onClick={() => {
                                returnDoc(docData, setOpenSuccess, setOpenError, setSuccessText, setErrorText
                                )
                            }}
                        >
                            เก็บเข้าแฟ้ม
                        </Button>
                    </CardContent>
                </Card>
                <Modal open={addModalOpen} onClose={handleModalClose}>
                    <Box
                        sx={modalStyle}
                        component="form"
                    >
                        <Typography variant="h6" mb={2}>
                            เพิ่มข้อมูลแปลง
                        </Typography>
                        <Stack spacing={2}>
                            <TextField
                                label="รหัสแปลงที่ดิน"
                                name="parcelCode"
                                value={modalForm.parcelCode}
                                onChange={handleModalFormChange}
                                error={!!validationErrors.parcelCode}
                                helperText={validationErrors.parcelCode}
                                fullWidth
                                margin="dense"
                            />
                            <TextField
                                label="รหัสแปลงที่ดินเก่า"
                                name="oldParcel"
                                value={modalForm.oldParcel}
                                onChange={handleModalFormChange}
                                error={!!validationErrors.oldParcel}
                                helperText={validationErrors.oldParcel}
                                fullWidth
                                margin="dense"
                            />
                            <TextField
                                label="ประเภทเอกสารสิทธิ์"
                                name="parcelType"
                                select
                                value={modalForm.parcelType}
                                onChange={(e) =>
                                    setModalForm({ ...modalForm, parcelType: e.target.value })
                                }
                                error={!!validationErrors.parcelType}
                                helperText={validationErrors.parcelType}
                                fullWidth
                                margin="dense"
                            >
                                {landTypeList.map((data, index) => (
                                    <MenuItem key={index} value={data.id_type}>
                                        {data.type_name}
                                    </MenuItem>
                                ))}
                            </TextField>
                            <TextField
                                label="เลขเอกสารสิทธิ์ที่ดิน"
                                name="dn"
                                value={modalForm.dn}
                                onChange={handleModalFormChange}
                                error={!!validationErrors.dn}
                                helperText={validationErrors.dn}
                                fullWidth
                                margin="dense"
                            />
                            <Stack direction="row" spacing={2} justifyContent="flex-end" mt={2}>
                                <Button variant="outlined" onClick={handleModalClose}>
                                    ยกเลิก
                                </Button>
                                <Button variant="contained" type='submit' onClick={handleModalFormSave}>
                                    บันทึก
                                </Button>
                            </Stack>
                        </Stack>
                    </Box>
                </Modal>
            </Box>
        </Box>
    )
}
